module.exports = __webpack_public_path__ + "media/images/avatar-c53bac8cf233dfa8f7febd994d74228b.png";